<template>
  <v-menu
    max-width="290"
    min-width="290"
    :close-on-content-click="false"
    v-model="isMenuOpened"
    rounded="0"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :label="$t('filters.dates')"
        @click="isMenuOpened = true"
        v-model="displayLabel"
        v-on="on"
        hide-details
        readonly
        outlined
        dense
      />
    </template>

    <v-list>
      <v-list-item
        class="filters__defaultFont"
        v-for="option in dateOptions"
        :key="option.title"
        @click="handleSelectPreset(option)"
      >
        {{ $t(`filters.date.${option.title}`) }}
      </v-list-item>

      <v-divider />

      <v-list-group append-icon="mdi-chevron-down">
        <template v-slot:activator>
          <v-list-item-title class="filters__defaultFont">
            {{ $t('filters.date.customRange') }}
          </v-list-item-title>
        </template>
        <v-list-item>
          <v-row class="filters__dates mt-0" no-gutters>
            <v-col class="pr-1">
              <v-menu v-model="menuStart" :close-on-content-click="false" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :label="$t('filters.date.startDate')"
                    v-model="startDateShow"
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    outlined
                    readonly
                    dense
                    @click:clear="clearStartDate"
                  />
                </template>
                <v-date-picker
                  v-model="startDateSelect"
                  color="primary"
                  no-title
                  :locale="locale"
                  @change="handleStartDateSelected"
                />
              </v-menu>
            </v-col>
            <v-col class="pl-1">
              <v-menu v-model="menuEnd" :close-on-content-click="false" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :label="$t('filters.date.endDate')"
                    v-model="endDateShow"
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    outlined
                    readonly
                    dense
                    @click:clear="clearEndDate"
                  />
                </template>
                <v-date-picker
                  v-model="endDateSelect"
                  :min="startDateSelect"
                  color="primary"
                  no-title
                  :locale="locale"
                  @change="handleEndDateSelected"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-menu>
</template>

<script>
import moment from 'moment'
import { dateOptions } from '@/components/filters/FilterDatesOptions'

export default {
  name: 'FinancialReportDateFilter',

  data() {
    return {
      isMenuOpened: false,
      displayLabel: '',
      dateOptions,

      startDateSelect: null,
      endDateSelect: null,
      startDateShow: null,
      endDateShow: null,
      menuStart: false,
      menuEnd: false,
    }
  },

  computed: {
    locale() {
      return localStorage.getItem('user_language') ?? 'pt-BR'
    },
  },

  methods: {
    handleSelectPreset(option) {
      this.startDateSelect = null
      this.endDateSelect = null
      this.startDateShow = null
      this.endDateShow = null

      this.displayLabel = this.$t(`filters.date.${option.title}`)
      this.isMenuOpened = false

      if (!option.days) {
        this.$emit('change', { start: null, end: null })
        return
      }

      if (option.title === 'recent') {
        const start = moment().subtract(1, 'month').format('YYYY-MM-DD')
        const end = moment().add(1, 'month').format('YYYY-MM-DD')
        this.$emit('change', { start, end })
        return
      }

      const start = moment().subtract(option.days, 'days').format('YYYY-MM-DD')
      const end = moment().format('YYYY-MM-DD')
      this.$emit('change', { start, end })
    },

    handleStartDateSelected() {
      this.menuStart = false
      this.startDateShow = moment(this.startDateSelect).format('DD/MM/YYYY')
      if (!this.endDateSelect) {
        this.endDateSelect = moment().format('YYYY-MM-DD')
        this.endDateShow = moment().format('DD/MM/YYYY')
      }
      this.updateDisplayLabel()
      this.emitRange()
    },

    handleEndDateSelected() {
      this.menuEnd = false
      this.endDateShow = moment(this.endDateSelect).format('DD/MM/YYYY')
      this.updateDisplayLabel()
      this.emitRange()
    },

    clearStartDate() {
      this.startDateSelect = null
      this.startDateShow = null
      this.updateDisplayLabel()
      this.emitRange()
    },

    clearEndDate() {
      this.endDateSelect = null
      this.endDateShow = null
      this.updateDisplayLabel()
      this.emitRange()
    },

    clearAll() {
      this.startDateSelect = null
      this.startDateShow = null
      this.endDateSelect = null
      this.endDateShow = null
      this.displayLabel = ''
      this.$emit('change', { start: null, end: null })
    },

    updateDisplayLabel() {
      if (this.startDateShow && this.endDateShow) {
        this.displayLabel = `${this.startDateShow} até ${this.endDateShow}`
      } else if (this.startDateShow) {
        this.displayLabel = `${this.startDateShow} em diante`
      } else if (this.endDateShow) {
        this.displayLabel = `até ${this.endDateShow}`
      } else {
        this.displayLabel = ''
      }
    },

    emitRange() {
      this.$emit('change', {
        start: this.startDateSelect || null,
        end: this.endDateSelect || null,
      })
    },
  },
}
</script>
